export default __webpack_public_path__ + "static/Montserrat-Regular-b71748ae4f80ec8c014def4c5fa8688b.woff2";